export const CONVAI_WIDGET_SRC = "https://unpkg.com/@elevenlabs/convai-widget-embed@0.5.4/dist/index.js";
export const AMANDA_AGENT_ID = "agent_7601kt73s4n7fn8rz1t34y9yssaz"; // WebEx
export const DEFAULT_SERVER_LOCATION = "eu-residency";
export const VOICE_AGENT_LEAD_DATA_LS_KEY = "voice_agent_lead_data";
export const DEFAULT_LEAD_DATA = {
    first_name: "Test",
    last_name: "User",
    company: "Acme Corp (dummy)",
    company_size: "11-50",
    address: "123 Fake Street, Testville",
    country_code: "US",
    email: "test.user@example.com",
    main_product: "work management",
    lead_context: "Dummy lead data for local/staging testing only",
    goal_summary: "Evaluating work management tools (placeholder — not a real lead)"
};
